import { Injectable, signal, WritableSignal } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  
  preferedLanguage: WritableSignal<string> = signal('');
  lang:string;

  constructor(
    private translate: TranslateService,
    private dateAdapter: DateAdapter<any>
  ){
    const langStored = localStorage.getItem('preferedLanguage');

    this.lang = langStored ?? 'en';
  }

  init(){
    this.setLanguage(this.lang);
  }

  setLanguage(language:string) {
    console.log('Setting application languages');
    
    this.preferedLanguage.set(language);
    localStorage.setItem('preferedLanguage', language);

    this.translate.use(language);
    this.dateAdapter.setLocale(language);
    
    console.log(`Application language: ${language}`);
  }

  getNotificationStatus(){
    if (("Notification" in window)) {
      return Notification.permission
    }
    return '';
  }

}
